import { OpportunityKind } from 'anchor-scout-common/types';
import { DiscountBadge, DollarCircle, Invoice } from 'seagull/icons/money';
import { TwoUsers } from 'seagull/icons/users';
export const KIND_ICON = {
    [OpportunityKind.StalePrice]: DollarCircle,
    [OpportunityKind.DiscountLeak]: DiscountBadge,
    [OpportunityKind.RecurringAdhoc]: Invoice,
    [OpportunityKind.CrossSell]: TwoUsers
};
export const BUILDING_UP_KINDS = [
    'stalePrice',
    'discountLeak',
    'recurringAdhoc',
    'crossSell'
];
export const OPPORTUNITY_BI_CONTAINER = 'pulse_opportunity';
export const SKELETON_ROW_WIDTHS = [
    220,
    180,
    240,
    200,
    190
];
